import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User played a video',
  name: 'played_video',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
